function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'framed-vertical': 'url("//creationsofchrist.com/cdn/shop/files/framed-vertical_68x.png?v=7641571398158306955")','framed-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/framed-horizontal_68x.png?v=17751924349057997200")','print-vertical': 'url("//creationsofchrist.com/cdn/shop/files/print-vertical_68x.png?v=17265908076749706893")','print-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/print-horizontal_68x.png?v=18279282354625651949")','unframed-vertical': 'url("//creationsofchrist.com/cdn/shop/files/unframed-vertical_68x.png?v=2199511629956049212")','unframed-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/unframed-horizontal_68x.png?v=2864613648787210657")','unframed': 'url("//creationsofchrist.com/cdn/shop/files/unframed_68x.png?v=2216173682983277475")','oak': 'url("//creationsofchrist.com/cdn/shop/files/oak_68x.jpg?v=314752646904752967")','espresso': 'url("//creationsofchrist.com/cdn/shop/files/espresso_68x.jpg?v=10304619316624774266")','black': 'url("//creationsofchrist.com/cdn/shop/files/black_68x.jpg?v=11302557100878306688")','silver': 'url("//creationsofchrist.com/cdn/shop/files/silver_68x.jpg?v=3079092621216233525")','gold': 'url("//creationsofchrist.com/cdn/shop/files/gold_68x.jpg?v=739286200179999961")','white': 'url("//creationsofchrist.com/cdn/shop/files/white_68x.jpg?v=11309712190830666979")','unframed': 'url("//creationsofchrist.com/cdn/shop/files/unframed_68x.png?v=2216173682983277475")',};

    this.triggers = ['frame color','type',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
